import {ErrorLike, gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';
import {ImageModel, MutationCreateQueueJobArgs, QueueJob} from '../__generated__/resolvers-types';

export const CREATE_IMAGE_TO_IMAGE_QUEUE_JOB = gql`
  mutation CreateQueueJob($job: QueueJobInput!) {
    createQueueJob(job: $job) {
      id
      status
    }
  }
`;

interface UseCreateImageToImageQueueJobOptions {
  onCompleted?: () => void;
  onError?: (error: Error) => void;
}

export interface CreateImageToImageJobArgs {
  projectId: string;
  model?: ImageModel | null;
}

interface UseCreateImageToImageQueueJobResult {
  createImageToImageJob: (args: CreateImageToImageJobArgs) => void;
  loading: boolean;
  data?: {createQueueJob: QueueJob};
  error?: ErrorLike;
}

export default function useCreateImageToImageQueueJob(
  options?: UseCreateImageToImageQueueJobOptions,
): UseCreateImageToImageQueueJobResult {
  const [createJob, rest] = useMutation<{createQueueJob: QueueJob}, MutationCreateQueueJobArgs>(
    CREATE_IMAGE_TO_IMAGE_QUEUE_JOB,
    {
      onCompleted: () => options?.onCompleted?.(),
      onError: options?.onError,
    },
  );

  const createImageToImageJob = (args: CreateImageToImageJobArgs) => {
    const {projectId, model} = args;
    return createJob({
      variables: {
        job: {
          imageToImageGeneration: {
            projectId,
            items: [],
            ...(model && {model}),
          },
        },
      },
    });
  };

  return {
    createImageToImageJob,
    loading: rest.loading,
    data: rest.data ?? undefined,
    error: rest.error,
  };
}
